import { cn } from '../lib/utils';

interface Props {
  label: string;
  value: string | number;
  accent?: 'gold' | 'pitch' | 'neutral';
  className?: string;
}

export function StatBox({ label, value, accent = 'neutral', className }: Props) {
  const valueColor =
    accent === 'gold' ? 'text-trophy-gold' : accent === 'pitch' ? 'text-pitch' : 'text-text-base';
  return (
    <div className={cn('flex-1 rounded-xl border border-border-base bg-bg-card p-4', className)}>
      <div className="font-display-alt text-xs uppercase tracking-widest text-text-faint">{label}</div>
      <div className={cn('font-mono text-3xl font-extrabold mt-1', valueColor)}>{value}</div>
    </div>
  );
}
